import { HseSelect } from "@hse-design/vue";
import { resourceLoader } from "../common/resourceLoader";
import { store } from "../../store/index";

const fields = {
  Topic: {
    value: "",
    isValid: false,
    isRequired: true,
    label: "fields.name.expert_topic",
    size: "large",
    component: HseSelect,
    eventId: "",
    setEvent(event) {
      this.value = "";
      this.eventId = event;
    },
    getAllOptions(search) {
      let reqParams = { event_id: this.eventId };

      if (store.state.extension.includes("scientific_manager")) {
        reqParams.type_manager = "scientific_manager";
        // search.type_manager = "scientific_manager";
      }
      return this.eventId
        ? resourceLoader.load("manager.eventTopics", reqParams, [], search)
        : Promise.resolve([]);
    },
  },
  event: {
    value: "",
    isValid: false,
    isRequired: true,
    label: "fields.name.event",
    size: "large",
    component: HseSelect,
    searchable: "dropdown",
    getAllOptions(search) {
      // return resourceLoader.load('manager.eventList', { }, [], search)
      console.log(store.state, "test");
      let reqParams = {};

      if (store.state.extension.includes("scientific_manager")) {
        reqParams.type_manager = "scientific_manager";
        // search.type_manager = "scientific_manager";
      }
      console.log(search, "search");
      return resourceLoader.load("manager.eventList", reqParams, [], search);
    },
  },
};

Object.keys(fields).forEach((key) => {
  fields[key].setValues = function (isValid, value = "") {
    this.value = value;
    this.isValid = isValid;
  };
});

export default fields;
